import React, { useState, useRef, useEffect } from 'react';
import ReactStrapTable from "components/reactStrapTable";
import DownloadIcon from "assets/icon/Download-Icon3.svg";
import { Button } from "reactstrap";
import useAxios from "hooks/useAxios";
import HoverImage from "react-hover-image/build";
import { dateOnly, cellRendererCheck } from 'utils/columns';
import Loader from "components/Loader";
import { cloneDeep, filter } from 'lodash';
import { onExport } from 'utils/helper';
import DownloadHover from "assets/icon/downloadhover.svg";


let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: "modifiedDate",
    order: "desc",
    filters: [],
};


const EncountersDrawer = (props) => {
    const API = useAxios()
    const { tenantID, orgId, randNum } = props
    const [encounterFileData, setEncounterFileData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalItem, setTotalItem] = useState(0);

    useEffect(() => {
        initialFilters = {
            currentPage: 1,
            pageSize: 10,
            orderBy: "modifiedDate",
            order: "desc",
            filters: [],
        };
        fetchEncounterFileSummary(initialFilters);
    }, [randNum]);

    const onPageChange = (filter, hasFilter) => {
        let detailFilter = cloneDeep(initialFilters);
        if (hasFilter) {
            detailFilter.currentPage = filter.currentPage
            fetchEncounterFileSummary(detailFilter, true);
        } else {
            detailFilter.currentPage = filter.currentPage
            fetchEncounterFileSummary(detailFilter);
        }
    };

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            initialFilters = { ...initialFilters, ...filter }
            let colFilterOn = { ...initialFilters, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        initialFilters = { ...initialFilters, ...filter }
        onPageChange(initialFilters);
    };



    const fetchEncounterFileSummary = async (filter) => {
        let payload = { ...filter };
        initialFilters = { ...initialFilters, ...filter }
        setLoading(true);
        if (!tenantID) return null;
        try {
            const { data } = await API.post(`RCMDashboard/${tenantID}/Dashboard/getEncounterfileSummary`, payload,
                {
                    hasDefaultURL: true,
                    hideLoader: false,
                }
            );
            if (data) {
                setEncounterFileData(data.items);
                setTotalItem(data.totalRecords);
                setLoading(false);
            } else {
                setEncounterFileData([]);
                setTotalItem(0);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    };


    const handleExport = async (fileId) => {
        let fileProcessID = "";
        if (fileId != "" && fileId != undefined && fileId > 0) {
            fileProcessID = fileId;
        }
        const { access_token } =
            JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
        const action = `${process.env.REACT_APP_ENDPOINT}/RCMDashboard/${tenantID}/Dashboard/dashboardEncounter?access_token=${access_token}`;
        onExport(action, fileProcessID);

    };


    const cellRenderEdit = (fileId) => {
        return (
            <div>
                <Button
                    color="link"
                    className="text-primary p-0 text-decoration-none align-items-center"
                    onClick={() => handleExport(fileId)}
                    title="Download"
                >
                    <HoverImage
                        key="DownloadIcon"
                        src={DownloadIcon}
                        hoverSrc={DownloadHover}
                        alt=""
                    />
                </Button>

            </div>
        );
    };


    const columns = [
        {
            dataField: "fileProcessID",
            text: "Options",
            width: 100,
            cellRenderer: (encounterFileData) => cellRenderEdit(encounterFileData.fileProcessID),
            show: true,
            hideColFilter: true,
            action: true,
        },
        {
            dataField: "dateProcessed",
            text: "Date Processed",
            show: true,
            width: 120,
            hideColFilter: true,
            sort: false,
            cellRenderer: (encounterFileData) => dateOnly(encounterFileData.dateProcessed),
        },
        {
            dataField: "fileName",
            text: "File Name",
            show: true,
            width: 120,
            hideColFilter: true,
            sort: false,
            cellRenderer: (encounterFileData) => cellRendererCheck(encounterFileData.fileName),
        },
        {
            dataField: "totalNoOfRecords",
            text: "Total no. of Records",
            show: true,
            width: 120,
            hideColFilter: true,
            sort: false,
            cellRenderer: (encounterFileData) => cellRendererCheck(encounterFileData.totalNoOfRecords),
        },
        {
            dataField: "successfulRecords",
            text: "Successful Records",
            show: true,
            width: 140,
            hideColFilter: true,
            sort: false,
            cellRenderer: (encounterFileData) => cellRendererCheck(encounterFileData.successfulRecords),

        },
        {
            dataField: "failedRecords",
            text: "Failed Records",
            show: true,
            width: 140,
            hideColFilter: true,
            sort: false,
            cellRenderer: (encounterFileData) => cellRendererCheck(encounterFileData.failedRecords),
        },
    ];

    return (
        <div>
            <div>
                <span className='text-primary font-weight-600'>Encounter History</span>
            </div>
            {loading && <Loader opacity={0.01} color="black" />}
            <div
                className="table-card scroll-table position-relative border-0 rounded pt-0 mt-3"
                fixed-height={encounterFileData.length > 0 ? "fixed-height" : "default"}
            >
                <ReactStrapTable
                    id="dashboardencounter"
                    fixedColumn
                    columns={columns}
                    data={encounterFileData}
                    hasPagination
                    onPageChange={onPageChange}
                    totalRecords={totalItem}
                    onPageSizeChange={onPageSizeChange}
                    pageSize={initialFilters.pageSize}
                    currentPage={initialFilters.currentPage}
                    isHideFilter={true}
                />
            </div >
        </div>

    );

};

export default EncountersDrawer;